import {
    FieldInCard,
} from 'app/types/form.types'

import {
    ContainerStatusChangeNote,
} from '../../../ContainerNotes.types'

import {
    AuditTrailConfig, StatusChangeConfig, getChangeConfig,
} from './notesConfigs'

type Fields = keyof ContainerStatusChangeNote

const containerStatusFields: FieldInCard<Fields>[] = [
    getChangeConfig({
        showOrder: true,
    }),
    StatusChangeConfig,
    {
        title: 'Location',
        className: 'location',
        fields: [{
            name: 'location',
            componentName: 'LocationObjectSelector',
            labelKey: 'Note.location',
        }],
    },
    AuditTrailConfig,
]

export default containerStatusFields
